import request from '@/utils/request'
const base = '/course/courseExam/lecturer'
// Preserve the server's business message after the shared interceptor rejects an Axios error.
// Shared login/error behavior and all other pages remain unchanged.
function read(path, params) {
  return request.get(`${base}/${path}`, { params }).catch(error => {
    const data = error && error.response && error.response.data
    if (data && (data.errorMessage || data.message)) error.message = data.errorMessage || data.message
    return Promise.reject(error)
  })
}
export default {
  context: () => read('context'),
  summary: () => read('summary'),
  papers: query => read('paperList', query),
  detail: paperId => read('paperDetail', { paperId }),
  bindingCapability: () => read('bindingCapability'),
  bindingOptions: params => read('bindingOptions', params)
}
